import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { authApi } from './api';

export function TwoFactorChallenge() {
  const { verify2fa, logout } = useAuth();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await verify2fa(code.trim());
    } catch (err) {
      setError(err.message || 'Invalid code');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <form className="auth-card" onSubmit={submit}>
        <div className="auth-brand">D2D</div>
        <h1>Two-factor authentication</h1>
        <p className="auth-lead">Enter the 6-digit code from your authenticator app.</p>
        {error && <div className="auth-error">{error}</div>}
        <label>
          Authenticator code
          <input
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]{6,8}"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </label>
        <button type="submit" className="auth-primary" disabled={busy}>
          {busy ? 'Verifying…' : 'Verify'}
        </button>
        <button type="button" className="auth-link" onClick={() => logout()}>
          Sign out
        </button>
      </form>
    </div>
  );
}

export function SetupTwoFactor() {
  const { refresh, logout } = useAuth();
  const [setup, setSetup] = useState(null);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    authApi
      .setup2fa()
      .then(setSetup)
      .catch((err) => setError(err.message || 'Could not start 2FA setup'));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      await authApi.enable2fa(code.trim());
      await refresh();
    } catch (err) {
      setError(err.message || 'Could not enable 2FA');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <form className="auth-card auth-card-wide" onSubmit={submit}>
        <div className="auth-brand">D2D</div>
        <h1>Enable authenticator 2FA</h1>
        <p className="auth-lead">
          Scan the QR code with Google Authenticator, 1Password, Authy, or similar. 2FA is required
          for all Energy Asset OS accounts.
        </p>
        {error && <div className="auth-error">{error}</div>}
        {setup && (
          <div className="auth-2fa-setup">
            <img
              src={`data:image/png;base64,${setup.qr_png_base64}`}
              alt="TOTP QR code"
              width={180}
              height={180}
            />
            <div className="auth-secret">
              <div className="auth-secret-label">Manual key</div>
              <code>{setup.secret}</code>
            </div>
          </div>
        )}
        <label>
          Confirm code
          <input
            inputMode="numeric"
            autoComplete="one-time-code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </label>
        <button type="submit" className="auth-primary" disabled={busy || !setup}>
          {busy ? 'Enabling…' : 'Enable 2FA & continue'}
        </button>
        <button type="button" className="auth-link" onClick={() => logout()}>
          Sign out
        </button>
      </form>
    </div>
  );
}
